import React, { useState } from "react";
import { motion } from "framer-motion";

const Navbar = ({ activeSection, darkMode, toggleDarkMode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: "intro", number: "00.", label: "Home" },
    { id: "about", number: "01.", label: "About" },
    { id: "internship", number: "02.", label: "Internships" },
    { id: "projects", number: "03.", label: "Projects" },
    { id: "contact", number: "04.", label: "Contact" },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      setIsMenuOpen(false);
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="
      fixed top-0 left-0 right-0 z-50
      bg-white/90 dark:bg-gray-900/90
      backdrop-blur-md shadow-md
      border-b border-gray-200 dark:border-gray-800
      transition-colors duration-300"
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-16 px-4">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection("intro")}>
            <div
              className="relative w-11 h-11 flex items-center justify-center 
    rounded-2xl
    border-2 
    border-teal-700 dark:border-accent
    text-teal-700 dark:text-accent
    font-bold text-lg
    transition-all duration-300
    hover:bg-teal-700 hover:text-white
    dark:hover:bg-accent dark:hover:text-gray-900
  ">
              {"</>"}
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`relative px-2 py-2 text-sm font-medium transition-colors flex items-center ${
                  activeSection === item.id
                    ? "text-teal-700 dark:text-accent"
                    : "text-gray-700 dark:text-gray-300 hover:text-teal-700 dark:hover:text-accent"
                }`}
              >
                <span className="text-teal-700 dark:text-accent">
                  {item.number}
                </span>
                <span className="ml-1">{item.label}</span>
              </button>
            ))}
          </div>

          {/* Right Side Buttons */}
          <div className="flex items-center space-x-4">
            {/* Dark Mode Toggle */}
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg 
              bg-gray-200 dark:bg-gray-800 
              hover:bg-gray-300 dark:hover:bg-gray-700 
              transition-colors"
              aria-label="Toggle dark mode"
            >
              {darkMode ? (
                <svg
                  className="w-5 h-5 text-yellow-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  className="w-5 h-5 text-gray-800"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg 
              bg-gray-200 dark:bg-gray-800"
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6 text-gray-800 dark:text-gray-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            className="md:hidden border-t border-gray-200 dark:border-gray-800"
          >
            <div className="px-4 py-4 space-y-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`block w-full text-left px-4 py-2 rounded-lg transition-colors flex items-center ${
                    activeSection === item.id
                      ? "bg-gray-200 dark:bg-gray-800 text-teal-700 dark:text-accent"
                      : "text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800"
                  }`}
                >
                  <span className="text-teal-700 dark:text-accent">
                    {item.number}
                  </span>
                  <span className="ml-1">{item.label}</span>
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;
